import React from "react";
import './Contact.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import emailus from './assets/emailus.png';
import call from './assets/call.png';
import location from './assets/location.png';

const Contact = () => {
    return (
        <>
            <div className="row">
                <div className="col-1 leftcol">
                    {/* <HomeLeft /> */}
                </div>
                <div className="col-10 middlecol">
                    <div class="container mt-4">
                        <div class="contact-info">
                            <div class="info-group">
                                <div>
                                    <img src={emailus} alt="Support" className="logo-image" />
                                    <p><a href="mailto:info@mitradingjp.com">info@mitradingjp.com</a></p>
                                    <p><a href="mailto:csd@mitradingjp.com">csd@mitradingjp.com</a></p>
                                </div>
                                <div>
                                    <img src={call} alt="Support" className="logo-image" />
                                    <p><a href="tel:+819053421744">+81 90-5342-1744</a></p>
                                    <p><a href="tel:+819081000786">+81 90-8100-0786 (CSD)</a></p>
                                </div>
                                <div>
                                    <img src={location} alt="Support" className="logo-image" />
                                    <p>315-0131 Ibaraki, Ken Ishioka Shi, Shimobayashi 3290-1</p>
                                </div>
                            </div>
                        </div>

                        <div class="quote-form">
                            <h4 class="text-center">Get A Quote</h4>
                            <form>
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" placeholder="Enter your name" />
                                    </div>
                                    <div class="col-md-6">
                                        <input type="email" class="form-control" placeholder="Enter email address" />
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <select class="form-control">
                                            <option>Select Service Type</option>
                                            <option>Service 1</option>
                                            <option>Service 2</option>
                                        </select>
                                    </div>
                                    <div class="col-md-6">
                                        <input type="text" class="form-control" placeholder="Enter phone number" />
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <textarea class="form-control" rows="4" placeholder="Enter message"></textarea>
                                </div>
                                <div class="mb-3 form-check">
                                    <input type="checkbox" class="form-check-input" id="saveInfo" />
                                    <label class="form-check-label" for="saveInfo">Save my name, email, and website for next time</label>
                                </div>
                                <button type="submit" class="btn btn-custom">GET A FREE SERVICE</button>
                            </form>
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-12">
                            <div className="map-container">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3218.6315758004102!2d140.23595028843866!3d36.22414892885064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60221094b3e5317d%3A0x94965b4eda7a19ff!2s3290-1%20Shimobayashi%2C%20Ishioka%2C%20Ibaraki%20315-0131%2C%20Japan!5e0!3m2!1sen!2s!4v1738968872792!5m2!1sen!2s"
                                    width="600"
                                    height="450"
                                    style={{ border: "0" }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Map"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-1 rightcol">
                    {/* <HomeRight /> */}
                </div>
            </div>
        </>
    );
};

export default Contact;
